
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

export default {
  name: 'ListingLicence',
  components: {
    Typography,
  },
  data() {
    return {
      TypographyType,
    };
  },
};
